import React, {useEffect, useState} from "react";
import {connect, useDispatch} from "react-redux";
import {withRouter} from "react-router-dom";
import {Alert, Button, Card, CardBody, Col, FormGroup, Label, Modal, Row,} from "reactstrap";
import {notification} from "antd";
import Breadcrumbs from "../../components/Common/Breadcrumb";

import {filialEn, filial} from '../../helpers/status'

const modalError = (type,message) => {
    notification[type]({
        message: 'Error',
        description: message,
    });
};
const modalSuccess = type => {
    notification[type]({
        message: 'Success',
        description: 'The operation was successfully performed',
    });
};


const Warehouse = props => {
    const dispatch = useDispatch();
    const [userData, setUserData] = useState({})
    const [AXID, setAXID] = useState('')
    const [trackingId, setTrackingId] = useState('')
    const [weight, setWeight] = useState('')


    const [sq1, setsq1] = useState(false)

    const [userDiv, setUserDov] = useState(false)
    const [nameEn, setNameEn] = useState('')
    const [lastNameEn, setLastNameEn] = useState('')

    useEffect(() => {
        if (AXID.toUpperCase() === 'AX') {
            setUserDov(true)
        } else {
            setUserDov(false)
            if (AXID.length === 7) {
                getUserSagaAsync(AXID.toUpperCase())
            } else {
                setUserData({})
            }

        }

    }, [AXID])

    const getUserSagaAsync = (item, setUser = null) => {
        const jwt = localStorage.getItem("token");

        fetch(`${process.env.REACT_APP_SERVER_URL}/api2/warehouse/searchUser/${item}`, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                'Authorization': `Bearer ${jwt}`,
            }
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.users.length > 0) {
                    setUserData(data.users[0])
                }
            })
            .catch((error) => {
                console.error("Ошибка при получении пользователя:", error);
            });
    };

    const [isSubmitting, setIsSubmitting] = useState(false);


    const handleAddProduct = () => {
        if (isSubmitting) return; // Защита от двойного клика

        setIsSubmitting(true); // Блокируем кнопку

        let item;
        if (sq1) {
            item = {
                weight: weight,
                productOrderId: trackingId,
                AXID: 'AX00XA',
                nameEn: nameEn,
                lastNameEn: lastNameEn,
                country: props.auth.admin.country
            };
        } else {
            item = {
                weight: weight,
                productOrderId: trackingId,
                AXID: AXID.toUpperCase(),
                country: props.auth.admin.country
            };
        }

        createProduct(item);

        // Разблокировать через 3 секунды
        setTimeout(() => {
            setIsSubmitting(false);
        }, 3000);
    };


    const createProduct = async (item) => {
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api2/warehouse/create`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(item)
            });
            const json = await response.json();
            if (json.success) {
                modalSuccess('success')
                let item = {
                    country: props.auth.admin.country
                }

                setAXID('')
                setTrackingId('')
                setWeight('')
                setNameEn('')
                setLastNameEn('')
            } else {
                modalError('error', json.message)
            }

        } catch (error) {
            modalError('error',error)
            console.error('Error fetching data:', error);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs breadcrumbItem="Warehouse"/>
                    {
                        props.auth.isAuthenticated
                            ?
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md="12">
                                            <FormGroup className="mb-3">
                                                <Label>AXID</Label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={AXID}
                                                    onChange={(e) => setAXID(e.target.value)}
                                                    name="AXID"
                                                />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md="12">
                                            <div className="square-switch">
                                                <input
                                                    type="checkbox"
                                                    id="square-switch1"
                                                    switch="none"
                                                    checked={sq1}
                                                    onChange={() => {
                                                        setsq1(!sq1)
                                                    }}
                                                />
                                                <label
                                                    htmlFor="square-switch1"
                                                    data-on-label="On"
                                                    data-off-label="Off"
                                                />
                                                <span style={{position: 'relative', bottom: '16px', marginLeft: '10px'}} >
                                                {/*Unknown*/}
                                                </span>
                                            </div>
                                        </Col>
                                    </Row>


                                    <Row>
                                        {
                                            sq1
                                                ? <>
                                                    <Col md="6">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="validationCustom02">Name</Label>
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                value={nameEn}
                                                                onChange={(e) => setNameEn(e.target.value)}
                                                                name="nameEn"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md="6">
                                                        <FormGroup className="mb-3">
                                                            <Label htmlFor="validationCustom02">Last Name</Label>
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                value={lastNameEn}
                                                                onChange={(e) => setLastNameEn(e.target.value)}
                                                                name="lastNameEn"
                                                            />
                                                        </FormGroup>
                                                    </Col>
                                                </>

                                                : <>

                                                    {
                                                        userData?.information?.nameEn && <Col xl={12}>
                                                            <h3>
                                                                <strong> Name: </strong> {userData?.information?.nameEn}{' '}{userData?.information?.lastNameEn},
                                                                <br/>
                                                                <strong>Branch: </strong> <span
                                                                style={{color: 'red'}}> {filialEn(userData?.takedPlaced?.address)}</span>
                                                                <br/>

                                                            </h3>
                                                        </Col>
                                                    }

                                                </>
                                        }

                                    </Row>

                                    <Row>


                                        <Col md="12">
                                            <br/>
                                        </Col>
                                        <Col md="12">
                                            <FormGroup className="mb-3">
                                                <Label>Tracking ID</Label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={trackingId}
                                                    onChange={(e) =>
                                                        setTrackingId(e.target.value.replace(/\s/g, ''))
                                                    }
                                                    name="trackingId"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="12">
                                            <FormGroup className="mb-3">
                                                <Label>Weight</Label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    value={weight}
                                                    onChange={(e) => setWeight(e.target.value.replace(/[^0-9\.]/g, ''))}
                                                    name="weight"
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col md="3" style={{paddingTop: '27px'}}>

                                            <Button
                                                onClick={handleAddProduct}
                                                color="primary"
                                                className="btn btn-success waves-effect waves-light"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? 'Please wait...' : 'Add'}
                                            </Button>
                                        </Col>
                                    </Row>

                                </CardBody>
                            </Card>

                            : <>Error</>
                    }


                    {/*
                    <Modal size="xl" isOpen={modal_xlarge}  toggle={() => { tog_large()  }} >
                        <div className="modal-header">
                            <h5
                                className="modal-title mt-0"
                                id="myExtraLargeModalLabel"
                            >
                                თრექინგ კოდი:
                                {product?.productOrderId}
                                { props.product.productOrderId}
                                {product.productOrderId}
                            </h5>
                            <button
                                onClick={() => {
                                    setmodal_xlarge(false)
                                }}
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                           {
                                !isEmpty(product._id)
                                    ?
                                    <>
                                        <Row>


                                            <Col md="3">
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="validationCustom02">მყიდველის სახელი</Label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        value={nameEn}
                                                        onChange={(e) => setNameEn(e.target.value)}
                                                        name="nameEn"
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col md="3">
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="validationCustom02">მყიდველი გვარი</Label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        value={lastNameEn}
                                                        onChange={(e) => setLastNameEn(e.target.value)}
                                                        name="lastNameEn"
                                                    />
                                                </FormGroup>
                                            </Col>


                                            <Col md="3">
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="validationCustom01">AXID</Label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        value={AXID}
                                                        onChange={(e) => setAXID(e.target.value)}
                                                        name="AXID"
                                                    />
                                                </FormGroup>
                                            </Col>


                                            <Col md="3">
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="validationCustom02">წონა</Label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        value={weight}
                                                        onChange={(e) => setWeight(e.target.value)}
                                                        name="weight"
                                                    />
                                                </FormGroup>
                                            </Col>


                                        </Row>
                                        <Row>

                                            <Col md="3">
                                                <Button
                                                    // onClick={handleUpdateInformation}
                                                    color="primary"
                                                    className="btn btn-primary waves-effect waves-light"
                                                >
                                                    დამახსოვრება
                                                </Button>
                                            </Col>
                                        </Row>
                                    </>
                                    : null
                            }

                        </div>
                    </Modal>

                    */}
                </div>
            </div>
        </React.Fragment>

    )
}


const mapStateToProps = state => {
    const {
        auth,
        products
    } = state
    return {
        auth,
        products
    }
};
export default withRouter(connect(mapStateToProps)(Warehouse));
